import { createFileRoute } from '@tanstack/react-router';
import { CommunityGuidelinesPage } from '../components/legal/CommunityGuidelinesPage';

export const Route = createFileRoute('/community-guidelines')({
  component: CommunityGuidelinesPage,
});
